export default __webpack_public_path__ + "static/media/Inter-ExtraLight.e22ca38c.ttf";